import React from 'react';
import { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const dropdownOptions = [
  'Physical Disability',
  'Visual Impairment',
  'Hearing Impairment',
  'Intellectual Disability',
  'Other',
];

const languages = [
  'Disability',
  'Type of Disability',
  'Economic Recovery',
  'SMMEs Development',
  'Rural Development',
  'Access to Markets',
  'Innovation',
  'Non',
];

const  GroupExperience = ({
  selected = [],
  setSelected,
  selectedType,
  setSelectedType,
  onSave
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false); // New state for expand/collapse

  const toggleExpand = () => {
    setIsExpanded(!isExpanded); // Toggle the expanded state
  };

  const handleSelect = (lang) => {
    if (lang === 'Type of Disability') {
      setShowDropdown(!showDropdown);
    } else {
      setSelected(prev =>
        prev.includes(lang) ? prev.filter(item => item !== lang) : [...prev, lang]
      );
    }
  };

  const handleDropdownOption = (option) => {
    setSelectedType(option);
    setShowDropdown(false);
  };

  const handleSave = () => {
    if (onSave) {
      onSave({
        SECTIOND: "AREAS OF FOCUS",
        typeOfFocus: "Areas of Focus",
        selectedAreas: selected,
        selectedDisabilityType: selectedType,
      });
    }
  };

  useEffect(() => {
    console.log("Section D Data:", {
      focusSelected: selected,
      selectedType
    });
    onSave({
      focusSelected: selected,
      selectedType
    });
  }, [selected, selectedType, onSave]);

  return (
    <div>
      {/* Header with dropdown toggle */}
      <div 
        className="w-full md:mt-5 mt-3 md:h-[133px] h-[70px] flex items-center justify-between border-b border-[#979797] bg-white rounded-b-[1px] rounded-[10px] md:mt-7 relative cursor-pointer"
        onClick={toggleExpand}
      >
        <div className="w-[154px] h-[70px] sm:w-[70px] sm:h-[100px]"></div>
        <div className="absolute left-1/2 transform -translate-x-1/2 md:text-[32px] text-center text-[12px] font-bold">
          AREAS OF FOCUS
          <p className="font-normal text-[8px] md:text-[24px]">Does your activities respond to the following</p>
        </div>
        <div className="md:w-[154px] md:h-[133px] w-[100px] h-[70px] bg-[#D9D9D9] rounded-br-[10px] flex items-center justify-center border-b border-black">
          <img
            src={`https://res.cloudinary.com/dzngpgki4/image/upload/${
              isExpanded 
                ? 'v1748785688/Expand_down_yilqh4.png' 
                : 'v1748785688/Expand_down_yilqh4.png' // You'll need an "up" icon
            }`}
            alt="expand icon"
            className="md:w-12 md:h-12 w-6 h-6"
          />
        </div>
      </div>

      {/* Content that shows/hides based on isExpanded */}
      {isExpanded && (
        <div className="grid grid-cols-2 md:gap-2 gap-1 md:mt-6 mt-2 relative">
          {languages.map((lang, i) => {
            const isActive = selected.includes(lang);
            const isDropdown = lang === 'Type of Disability';
            return (
              <div key={i} className="relative">
                <button
                  onClick={() => handleSelect(lang)}
                  className={`flex items-center justify-between w-full md:h-[70px] h-[20px] text-left rounded-[5px] md:px-4 px-2 ${
                    isDropdown ? 'bg-[#D9D9D9]' : 'bg-[#E7EBEB]'
                  }`}
                >
                  <span className="font-medium text-[4px] md:text-[24px] leading-[1.10] md:w-[500px]">
                    {isDropdown && selectedType ? selectedType : lang}
                  </span>
                  {isDropdown ? (
                    <div className='md:px-8'>
                      <ChevronDown className="w-3 h-3 md:w-6 md:h-6 " />
                    </div>
                  ) : (
                    <span
                      className={`md:w-14 md:h-14 w-3 h-3 rounded-full ${
                        isActive
                          ? 'bg-[#2E453D] md:border-[8px] border-[3px] border-white'
                          : 'md:border-[8px] border-[3px] border-white bg-[#D9D9D9]'
                      }`}
                    />
                  )}
                </button>
                {isDropdown && showDropdown && (
                  <div className="absolute z-10 left-0 right-0 bg-white shadow-md rounded-md mt-1">
                    {dropdownOptions.map((option, idx) => (
                      <div
                        key={idx}
                        onClick={() => handleDropdownOption(option)}
                        className="px-4 py-2 text-[6px] md:text-[18px] hover:bg-[#E7EBEB] cursor-pointer"
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default GroupExperience;